const styles = (theme) => ({
  allRecommendationContainer: {
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "4 8",
    backgroundColor: theme.ComponentHeader,
    height: "100%"
  },
  innerAllRecommendationContainer: {
    overflow: "auto",
    flex: "auto",
  },
  recommendationContainer: {
    backgroundColor: theme.ModalBGColor,
  },
  recommendedDrivers: {
    height: "101px",
    margin: 1,
    marginBottom: "5px",
  },
  upperDetails: {
    borderBottom: `1px solid ${theme.borderColor}`,
    height: "50%",
    position: "relative",
    display: "flex",
  },
  routeIcon: {
    width: "15px",
    height: "50%",
    position: "absolute",
    top: "27%",
    left: "4%",
  },
  bestChoiceSection: {
    display: "flex",
  },
  detailsContainer: {
    position: "absolute",
    top: "10%",
    left: "10%",
    display: "flex",
    width: "58%",
    flexDirection: "column",
    flexWrap: "wrap",
  },
  width100: {
    width: "100%",
  },
  bestChoice: {
    width: 78,
    color: theme.warningColor,
    fontWeight: 700,
    display: "block",
    fontSize: theme.textFontSize,
  },
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  upperEnrouteToTitle: {
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 600,
    color: theme.recommendationCardStatusTextColor,
  },

  assignBtn: {
    position: "absolute",
    top: "24%",
    right: "2%",
    width: "25%",
    height: "56%",
    '&$disabledButton': {
      backgroundColor: theme.disabledColor,
      color: theme.TextColor,
      opacity: 0.8
    }
  },
  disabledButton: {},
  lowerDetails: { height: "50%", position: "relative" },
  loader: {
    marginRight: 8
  },
  error: {
    color: theme.ErrorMessageColor,
  },
  noRecommendations: { 
    textAlign: "center",
    fontSize: theme.headerTextFontSize16,
    fontWeight: 500,
    lineHeight: "100px",
    color: theme.iconColor,
  },
  driverNameContainer: {
    whiteSpace: "nowrap",
  },
  driverNameContainerWithBestChoice: {
    width: 158,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "auto",
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize
  },
  highlightBoarder: {
    marginBottom: 2,
    border: `2px solid ${theme.palette.primary.main}`,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    flex: "auto",
    overflowY: "auto"
  },
  tooltip: {
    zIndex:99999
  },

  recommendationCardDetailsContainer: {
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "8px 10px",
  },

  recommendationCardDetail: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    '&:last-child': {
      alignItems: 'flex-end'
    }
  },
  recommendationCardDetailLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.recommendationCardStatusTextColor,
    fontWeight: 400,
    padding: 0,
  },
  recommendationCardDetailValue: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    color: theme.gridTextColor,
  },
  missedStops: {
    color: theme.ErrorMessageColor,
  },
});

export default styles;